import { InboxIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
interface Props { message?: string; description?: string; action?: ReactNode; icon?: ReactNode }
export function EmptyState({ message, description, action, icon }: Props) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center gap-3">
      <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center text-gray-400">
        {icon || <InboxIcon size={24} />}
      </div>
      <p className="text-sm font-semibold text-gray-600">{message ?? t('common.noData')}</p>
      {description && <p className="text-xs text-gray-400 max-w-xs">{description}</p>}
      {action}
    </div>
  )
}
